<template>
  <div class="attendee-notes-section">
    <template v-if="notes.length > 0">
    <div class="notes-item" v-for="note in notes" :key="note.id">
          <span>{{$t('participantManagament.registrationSearch.detailsParticipant.attendeeNotes.note')}}</span>
          <span>{{note.message}}</span>
          <span>{{$t('participantManagament.registrationSearch.detailsParticipant.attendeeNotes.registrationDate')}}</span>
          <span><b>{{ $moment(note.createDate).format("DD MMMM YYYY, dddd HH:mm") }}</b> - <span v-if="note.owner != null" v-html="$t('participantManagament.registrationSearch.detailsParticipant.attendeeNotes.createBy',[note.owner.firstName + ' ' + note.owner.lastName[0]])"></span> </span>
        </div>
    </template>
    <el-alert v-else type="info" :show-icon="true" :title="$t('participantManagament.registrationSearch.detailsParticipant.attendeeNotes.noNote')" :closable="false"></el-alert>

    
    <!-- <div class="notes-item">
      <span>Not</span>
      <span>Bu arkadaş biraz sıkıntılı...</span>
      <span>Kayıt tarihi</span>
      <span><b>11 May 2022, 17:07</b> - Özkan T. tarafından oluşturuldu.</span>
      <div class="attendee-notes-edit">
        <el-tooltip class="item" effect="dark" :content="$t('event.buttons.edit')" placement="top-start">
          <el-button type="success" size="small" icon="fas fa-pen" circle></el-button>
        </el-tooltip>
        <el-tooltip class="item" effect="dark" :content="$t('event.buttons.delete')" placement="top-start">
          <el-popconfirm :title="$t('generic.deleteSure')" :cancel-button-text="$t('generic.operationCancel')" :confirm-button-text="$t('generic.deleteYes')" icon-color="red">
            <el-button type="danger" size="small" icon="fas fa-trash" slot="reference" circle></el-button>
          </el-popconfirm>
        </el-tooltip>
      </div>
    </div> -->
  </div>
</template>

<script>
export default {
  props: ['notes']
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/participants/ParticipantDetails/AttendeeNotes.vue